module.exports = __webpack_public_path__ + "img/pic_haifan@2x.7cb3ef65.png";